var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKarate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pictogram",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M92.8,83.5h-40v23.9l-24.5,14.1c-2.5,1.4-3.3,4.6-1.9,7c1.4,2.5,4.6,3.3,7,1.9l27-15.6c1.7-1,2.6-2.8,2.6-4.6V93.8h24.6 v32.1c0,2.8,2.3,5.1,5.1,5.1s5.1-2.3,5.1-5.1V88.7C97.9,85.8,95.6,83.5,92.8,83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.8,41.3c-1-1-2.3-1.5-3.6-1.5H55.5c-1.3,0-2.7,0.5-3.7,1.5L31.4,61.8c-2,2-2,5.3,0,7.3c1,1,2.3,1.5,3.6,1.5h18v7.8 h23.1V50.1h36c1.3,0,2.6-0.5,3.6-1.5c1-1,1.5-2.3,1.5-3.6C117.3,43.6,116.8,42.3,115.8,41.3z M47.4,60.3l5.5-5.5v5.5H47.4z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 65.5,
    cy: 27,
    rx: 9,
    ry: 9
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKarate);
export default __webpack_public_path__ + "static/media/karate.1fd25e07f9419d4a86ba7c902d3b492d.svg";
export { ForwardRef as ReactComponent };